import { GET_CULTURE_CENTRE_COUNTRIES, GET_CULTURE_CENTRE_COUNTRIES_SUCCESS, GET_CULTURE_CENTRE_COUNTRIES_FAILURE } from "../constants";
import Axios from "axios";

const getCountriesList = () => {
  return async (dispatch: any) => {
    dispatch({ type: GET_CULTURE_CENTRE_COUNTRIES });
    Axios.get(`${process.env.REACT_APP_ASSETS_URL}/halo/culture_centre/countries.json`).then(function(payload) {
      dispatch({ type: GET_CULTURE_CENTRE_COUNTRIES_SUCCESS, payload: payload.data });
    }).catch(error => {
      dispatch({ type: GET_CULTURE_CENTRE_COUNTRIES_FAILURE, payload: error });
    })
  };
};

export default { getCountriesList };
